export class Global {
  public static BASE_CALCULATION_ENDPOINT = 'api/calculation/';
  public static BASE_OFFERT_ENDPOINT = 'api/offert/';
  public static BASE_ANTRAG_ENDPOINT = 'api/antrag/';
  public static BASE_OFFERTBASE_ENDPOINT = 'api/offertbase/';
  public static BASE_PARTNER_ENDPOINT = 'api/partner/';
  public static BASE_SETTINGS_ENDPOINT = 'api/settings/';
  public static BASE_USERSTATUS_ENDPOINT = 'api/userstatus/';
  public static BASE_VERMITTLER_ENDPOINT = 'api/vermittler/';
  public static BASE_EUROTAX_ENDPOINT = 'eurotax/';
  public static GEBURTSDATUM_MIN_DATE = new Date(Date.UTC(1800, 0, 1));
  public static ERSTZULASSUNGSDATUM_MIN_DATE = new Date(Date.UTC(1800, 0, 1));
  public static ERSTZULASSUNGSDATUM_CO2 = new Date(2020, 9, 1);
}
